import {Component, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UserAuthService} from '../../../../@core/user-auth.service';
import {take, takeUntil} from 'rxjs/operators';
import {User} from '../../../../models/user';
import {RequestHandler} from '../../../../@core/utils/request-handler';
import {from, Subject} from 'rxjs';
import {UnsubscribeComponent} from '../../../../@core/fc-component';
import {extractErrorMessage} from '../../../../utils/error.utils';
import {ConfigService} from '../../../../@core/config.service';
import {SSOService} from '../../../../@core/sso.service';
import {JWTService} from '../../../../@core/jwt.service';

@Component({
    selector: 'app-login-modal',
    templateUrl: './login-modal.component.html',
    styleUrls: ['./login-modal.component.scss'],
    host: {'data-test-id': 'login-modal'},
})
export class LoginModalComponent extends UnsubscribeComponent implements OnInit {
    email: string;
    password: string;
    retries: number;
    errorMessage: string;
    user: User;
    reAuthRequest = new RequestHandler(
        (email, password) => from(this.userAuth.login(email, password, true)),
        {
            showErrorToast: false,
            destroy$: this.destroy$,
        }
    );

    private _cancelSso$ = new Subject<void>();

    constructor(public configService: ConfigService,
                private activeModal: NgbActiveModal,
                private jwtService: JWTService,
                private ssoService: SSOService,
                private userAuth: UserAuthService) {
        super();
    }

    ngOnInit(): void {
        if (!UserAuthService.hasUser) {
            this.activeModal.dismiss('No credentials present in previous User Model');
            return;
        }

        this.userAuth.user.pipe(take(1)).subscribe(user => {
            this.email = user.email;
            this.retries = 3;
            this.user = user;
        });
    }

    handleLogin() {
        if (!this.email || !this.password) return;

        this.reAuthRequest.call(this.email, this.password).subscribe(() => {
            this._handleLoginSuccess();
        }, err => {
            this._handleLoginError(err);
        });
    }

    SSOLogin() {
        this._cancelSso$.next();
        this.ssoService.openSSOLogin().pipe(takeUntil(this.destroy$), takeUntil(this._cancelSso$)).subscribe({
            next: res => {
                if (res.success) {
                    this.jwtService.setToken(res.token, res.refresh_token, false);
                    this._handleLoginSuccess();
                } else {
                    this._handleLoginError(res.error);
                }
            },
            error: err => this._handleLoginError(err),
        });
    }

    handleLogout() {
        this.activeModal.dismiss('logout');
    }

    private _handleLoginSuccess() {
        this.activeModal.close('Successful login');
    }

    private _handleLoginError(err) {
        this.errorMessage = err.non_field_errors ? err.non_field_errors.join('. ') : extractErrorMessage(err);
        this.retries -= 1;
        this._handleRetries();
    }

    private _handleRetries() {
        this.password = '';
        if (this.retries > 0) return;

        this.activeModal.dismiss('logout');
    }
}
